import type { ILink, ILinkChain, INote, ISchema } from "~/models/IUserEntry";
import { useModal, useModalSlot } from "vue-final-modal";
import UserEntryDeleteModal from "~/components/legaltextparagraph/userentries/UserEntryDeleteModal.vue";
import LinkDelete from "~/components/legaltextparagraph/link/loop/LinkDelete.vue";

type DeleteableEntry = ISchema | INote | ILink | ILinkChain;

type ModalEventHandlers = {
  onClosed?: () => void;
  onDeleted?: () => void;
};

function buildGenericModal(
  entry: DeleteableEntry,
  handlers: ModalEventHandlers,
  slots?: { default: any }
) {
  return useModal({
    component: UserEntryDeleteModal,
    attrs: {
      entry,
      showTitle: !slots,
      ...handlers,
    },
    slots,
  });
}

function buildSchemaModal(
  entry: DeleteableEntry,
  handlers: ModalEventHandlers
) {
  return buildGenericModal(entry, handlers);
}

function buildNoteModal(entry: DeleteableEntry, handlers: ModalEventHandlers) {
  const resetNotesSelection = () => {
    // reset history cursor selection
    const range = document.createRange();
    range.setStart(document.body, 0);
    window.getSelection()?.addRange(range);

    const toolbars: NodeListOf<HTMLDivElement> = document.querySelectorAll(
      ".tox.tox-tinymce.tox-tinymce-inline"
    );
    toolbars.forEach((element) => {
      element.style.display = "none";
    });
  };

  return buildGenericModal(entry, {
    onDeleted: resetNotesSelection,
    ...handlers,
  });
}

function buildLinkModal(entry: DeleteableEntry, handlers: ModalEventHandlers) {
  return buildGenericModal(entry, handlers, {
    default: useModalSlot({
      component: LinkDelete,
      attrs: {
        link: entry as ILink | ILinkChain,
      },
    }),
  });
}

export function useEntryDeleteModal(handlers: ModalEventHandlers = {}) {
  const buildModal = (entry: MaybeRefOrGetter<DeleteableEntry>) => {
    const val = toValue(entry);
    const type = val.type;
    if (type === "schema") {
      return buildSchemaModal(val, handlers);
    } else if (type === "note") {
      return buildNoteModal(val, handlers);
    } else {
      return buildLinkModal(val, handlers);
    }
  };

  // const app = getCurrentInstance();

  const open = (entry: MaybeRefOrGetter) => {
    // app?.appContext?.app.runWithContext(() => {
    const modal = buildModal(entry);
    return modal.open();
    // });
  };

  return { open };
}
